import { Phone, Mail } from "lucide-react";
import { BRAND } from "../lib/brand";

/** Sticky mobile contact bar — bottom of viewport, mobile only.
 *  Sits ABOVE the floating WhatsApp & AI chatbot bubbles thanks to its z-index
 *  and is invisible on tablet/desktop so it never blocks layout there.
 */
export default function StickyContact() {
  return (
    <div
      data-testid="sticky-mobile-contact"
      className="lg:hidden fixed bottom-0 inset-x-0 z-[55] px-3 pb-3 pointer-events-none"
    >
      <div className="pointer-events-auto bg-[rgba(10,10,10,0.92)] backdrop-blur-xl border border-white/10 rounded-2xl shadow-2xl flex divide-x divide-white/10 overflow-hidden">
        <a
          href={BRAND.phoneTel}
          data-testid="sticky-call"
          className="flex-1 flex items-center justify-center gap-2 py-3 text-sm font-semibold text-white"
        >
          <Phone className="w-4 h-4 text-[#FF6A00]" /> Call
        </a>
        <a
          href="/contact"
          data-testid="sticky-strategy"
          className="flex-1 flex items-center justify-center gap-2 py-3 text-sm font-semibold bg-[#FF6A00] text-black"
        >
          <Mail className="w-4 h-4" /> Book call
        </a>
      </div>
    </div>
  );
}
